import React from 'react';
// features
import ProfilePhoto from '../../../profile/components/profile-photo';
// helpers/constants
import * as G from '../../../../helpers';
//////////////////////////////////////////////////

export default ({ iconsColor, currentUserSettings }) => {
  const settings = currentUserSettings || {};

  return (
    <ProfilePhoto
      {...G.getUserInfo(settings)}
      isAvatar={true}
      iconsColor={iconsColor}
      photoUrl={settings.profilePhotoUrl}
      userGuid={G.getGuidFromObject(settings)}
    />
  );
};
